import Box from "@mui/material/Box";
import React, { FC, ReactNode, useCallback, useEffect, useRef } from "react";

export interface IModalBodyProps {
  children: ReactNode;
  hasScroll?: boolean;
  setHasScroll?: (hasScroll: boolean) => void;
  disableBodyPadding?: boolean;
}

const ModalBody: FC<IModalBodyProps> = ({
  children,
  setHasScroll,
  hasScroll,
  disableBodyPadding,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const setScroll = useCallback(
    (scroll: boolean) => {
      if (setHasScroll) {
        setHasScroll(scroll);
      }
    },
    [setHasScroll],
  );

  useEffect(() => {
    if (hasScroll) {
      return;
    }
    const { offsetHeight, scrollHeight } = scrollRef.current || {};
    if (!!scrollHeight && !!offsetHeight) {
      setScroll(offsetHeight < scrollHeight);
    }
  }, [setScroll, hasScroll]);

  return (
    <Box
      ref={scrollRef}
      sx={{
        py: disableBodyPadding ? 0 : hasScroll ? 6 : 0,
        px: disableBodyPadding ? 0 : 6,
        flex: 1,
        overflow: "auto",
      }}
    >
      {children}
    </Box>
  );
};

export default ModalBody;
